import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PowerMeterReadingApi} from '@core/backend/engin/api/load-profile-analysis/power-meter-reading.api';
import {PowerMeterReadingService} from '@core/interfaces/engin/load-profile-analysis/power-meter-reading';
import {SimpleSeries} from '@core/interfaces/system/system-common';
import {LpInfrastructureRequest} from '@core/interfaces/engin/load-profile-analysis/lp-common.model';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {DownloadCSVUrl} from '@core/interfaces/engin/workflow-validation';

@Injectable()
export class PowerMeterReadingServiceImpl extends PowerMeterReadingService {
    constructor(private api: PowerMeterReadingApi) {
        super();
    }

    public getInfrastructureNetLoad(
        batchNumber: number,
        data: LpInfrastructureRequest,
    ): Observable<SimpleSeries<Date, number>[]> {
        return this.api.getInfrastructureNetLoad(batchNumber, data);
    }

    public getMetersByBatch(
        batchNumber: number,
        data: LpInfrastructureRequest,
    ): Observable<SimpleSeries<Date, number>[]> {
        return this.api.getMetersByBatch(batchNumber, data);
    }

    public listCorrectedReadingDtos(batchNumber: number, additionalQueryParam?: string): Observable<DataSource> {
        return this.api.listCorrectedReadingDtos(batchNumber, additionalQueryParam);
    }

    public downloadCorrectedReadings(batchNumber: number, paramsString?: string): Observable<DownloadCSVUrl> {
        return this.api.downloadCorrectedReadings(batchNumber, paramsString);
    }
}
